/** Trendmulti Chat — staging (`hml-chat.trendmulti.com.br`). */
export const environment = {
  production: true,
  env: 'staging',
  apiUrl: 'https://staging-api.trendmulti.com.br/api',
  trendWebAppUrl: 'https://hml-app.trendmulti.com.br',
  trendWebChatUrl: 'https://hml-chat.trendmulti.com.br',
  trendWebsocketUrl: 'wss://staging-websocket.trendmulti.com.br',
  socketActived: true,
  firebase: {
    apiKey: 'AIzaSyDwaQRKkoYjB2wABnzOyTTdsyKloHSO-LA',
    authDomain: 'zapteck-2707e.firebaseapp.com',
    databaseURL: 'https://zapteck-2707e.firebaseio.com',
    projectId: 'zapteck-2707e',
    storageBucket: 'zapteck-2707e.appspot.com',
    messagingSenderId: '1065124905487',
    appId: '1:1065124905487:web:151104c20ff06dcab2197a',
    measurementId: 'G-JHRXV6S0LG',
    vapidKey: 'BM6YHB9AvzZmrSIl35Pr9abjTGPF_Re4em6lxZYKsvFd1J0FH69PPyVDzz9A74PUbjjDavx02u2NgtxL1BQlisg',
  },
  recaptchaToken: '6LfS5TQsAAAAAGLdQSncEX79JztmSXDSt0c8Hqpa',
};
